module.exports = __webpack_public_path__ + "static/media/tribal.858a7cd3.jpg";